import type { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Spinner } from "@/components/ui/spinner";

/** Covers a list that already rendered while a follow-up fetch replaces it. */
export function RefreshOverlay({
  active,
  label,
  children,
}: {
  active: boolean;
  label: string;
  children: ReactNode;
}) {
  return (
    <div className="relative">
      {active && (
        <div className="absolute inset-0 z-20 flex flex-col items-center justify-center gap-2 rounded-xl bg-background/80">
          <Spinner className="size-5" />
          <p className="text-sm text-text-muted">{label}</p>
        </div>
      )}
      <div
        className={cn(active && "pointer-events-none")}
        aria-busy={active || undefined}
      >
        {children}
      </div>
    </div>
  );
}
